import ImageZoneBox from './ImageZoneBox'
import { IDiagnosticImageReport } from '../../../types/diagnostic-image'
import { styles } from '../styles'
import { Text, View } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'

interface DiscussionBoxProps {
  diagnosticImages: IDiagnosticImageReport[] | undefined
  imageSources: Record<string, string>
}

const DiscussionBox = ({
  diagnosticImages,
  imageSources,
}: DiscussionBoxProps) => {
  const { t } = useTranslation()

  return (
    <View break>
      <Text style={[styles.subtitle, styles.boldText, styles.underlineText]}>
        {t('sharedDiagnostic.comments.discussion')}
      </Text>

      {diagnosticImages?.map((diagnosticImage) => (
        <ImageZoneBox
          key={diagnosticImage.id}
          diagnosticImage={diagnosticImage}
          imageSources={imageSources}
        />
      ))}
    </View>
  )
}

export default DiscussionBox
